import gql from 'graphql-tag';

export const CREATE_NOTE_MUTATION = gql`
  mutation createNote($testatorId: ID!, $comment: String!) {
    createNote(testatorId: $testatorId, comment: $comment) {
      id
      testatorId
      comment
      createdAt
      postedByUser {
        id
        fullName
      }
    }
  }
`;

export const TESTATOR_NOTES_QUERY = gql`
  query Testator($id: ID!) {
    testator(id: $id) {
      id
      notes {
        id
        testatorId
        comment
        createdAt
        postedByUser {
          id
          fullName
        }
      }
    }
  }
`;
